import React, { Fragment } from 'react';
import PropTypes from 'prop-types';
import { FormattedMessageWrappedInSpan } from '../../misc';

import GDPRHint from '../GDPRHint';
import LoginForm from '../LoginForm';
import { UserConsumer } from '../../context/UserContext';

import { trackEvent } from '../../../utils/ga-tracking';
import KeyboardBackspaceRoundedIcon from '@material-ui/icons/KeyboardBackspaceRounded';


/////////////////////////////////////
// TODO missing test
/////////////////////////////////////

const CheckoutOrderingRegisterStep = (props) => {
  const {
    onContinueAsGuest,
    onRequestLogin,
    onOpenNotificationDialog,
    onPreviousStep
  } = props;

  return (
    <UserConsumer>
      {({ onCookiesChange }) => (
        <Fragment>
          <div className="row ordering-steps-checkout-type">
            <div className="ordering-steps-guest-checkout col-xs-16 col-sm-5 col-sm-offset-3">
              <h1>
                <FormattedMessageWrappedInSpan
                  id="checkoutOrderingRegisterStep.guestCheckout.title"
                  defaultMessage="Guest Checkout"
                />
              </h1>
              <FormattedMessageWrappedInSpan
                id="checkoutOrderingRegisterStep.guestCheckout.subtitle"
                defaultMessage="Proceed to checkout and we create an account for you at the end"
              />
              <div>
                <button
                  className="btn-default primary-new active"
                  onClick={() => {
                    onContinueAsGuest();
                    trackEvent('Checkout', 'Register', 'Continue as guest');
                  }}
                >
                  <FormattedMessageWrappedInSpan
                    id="checkoutOrderingRegisterStep.guestCheckout.continueButton"
                    defaultMessage="Continue as guest"
                  />
                </button>
              </div>
            </div>
            <div className="ordering-steps-login col-xs-16 col-sm-5">
              <h1>
                <FormattedMessageWrappedInSpan
                  id="checkoutOrderingRegisterStep.returningCustomer.title"
                  defaultMessage="Returning Customer"
                />
              </h1>
              <LoginForm
                onCookiesChange={onCookiesChange}
                onRequestLogin={onRequestLogin}
                onOpenNotificationDialog={onOpenNotificationDialog}
              />
            </div>
            <div className="navigation-back mt-15" onClick={onPreviousStep}>
            <KeyboardBackspaceRoundedIcon />
            <FormattedMessageWrappedInSpan
              id="checkoutOrderingPaymentStep.backButtonItems"
              defaultMessage="Back to cart"
            />
          </div>
          </div>
          <div className="row">
            <div className="col-xs-16 col-sm-10 col-sm-offset-3">
              <GDPRHint className="ordering-steps-register-gdpr center-text" />
            </div>

          </div> 
         
        </Fragment>
      )}
    </UserConsumer>
  );
};

CheckoutOrderingRegisterStep.propTypes = {
  onContinueAsGuest: PropTypes.func,
  onRequestLogin: PropTypes.func,
  onOpenNotificationDialog: PropTypes.func,
  onPreviousStep: PropTypes.func
};

export default CheckoutOrderingRegisterStep;
